const o=(o,t,c)=>o+(t-o)*c;export{o as mixNumber};
